<template>
  <base-input :rules="internalRules" :errors="errors">
    <div
      :class="[
        inline
          ? 'relative mt-1'
          : `relative border rounded-md focus-within:ring-1 ring-0 flex items-center transition-all ease-in-out duration-100 bg-white z-auto mt-1 focus-within:ring-${focusColor} focus-within:border-${focusColor} border-${borderColor}`,
      ]"
    >
      <label :class="['absolute -top-2 left-2 -mt-px inline-block px-1 bg-white text-xs font-normal z-10', `text-${labelColor}`]" v-if="label">{{ label }}</label>
      <datepicker
        :model-value="dateValue"
        :typeable="typeable"
        @update:model-value="handleInput($event)"
        :placeholder="placeholder"
        :input-format="inputFormat"
        :lower-limit="lowerLimit"
        :starting-view="initialView"
        :weekStartsOn="0"
      />
    </div>
  </base-input>
</template>

<script>
import Datepicker from "vue3-datepicker";
import moment from "moment";
import validatable from "@/mixins/validatable";

export default {
  mixins: [validatable],
  components: {
    Datepicker,
  },
  props: {
    modelValue: [Date, String],
    label: String,
    placeholder: String,
    typeable: { type: Boolean, default: true },
    inline: { type: Boolean, default: false },
    size: {
      type: String,
      default: "sm",
    },
    disabledDates: Object,
    minDate: [Date, String],
    initialView: {
      type: String,
      default: "day",
    },
  },
  emits: ["update:modelValue"],
  computed: {
    focusColor() {
      return this.hasError ? "red-500" : "primary-500";
    },
    borderColor() {
      return this.hasError ? "red-500" : "gray-200";
    },
    labelColor() {
      return this.hasError ? "red-500" : "gray-900";
    },
    placeholderColor() {
      return this.hasError ? "red-400" : "gray-500";
    },
    inputFormat() {
      return "MMMM d, yyyy";
    },
    dateValue() {
      return this.convertToDate(this.modelValue);
    },
    lowerLimit() {
      if (this.disabledDates && this.disabledDates.to) return this.convertToDate(this.disabledDates.to);
      if (this.minDate) return this.convertToDate(this.minDate);
      return undefined;
    },
  },
  methods: {
    handleInput(event) {
      this.validate();
      this.$emit("update:modelValue", event);
    },
    reset() {
      this.isResetting = true;
      this.$emit("update:modelValue", null);
    },
    convertToDate(dateValue) {
      if (!dateValue) return null;
      if (dateValue instanceof Date) return dateValue;
      if (typeof dateValue === "string") {
        return moment(dateValue, "YYYY-MM-DD").toDate();
      }
      return dateValue;
    },
  },
};
</script>

<!-- styles for .v3dp__* selectors live in src/assets/main.css (Tailwind 4
     @apply doesn't work in SFC <style> blocks without @reference) -->

<style>
.v3dp__input_wrapper input,
.v3dp__popout .v3dp__elements button {
  font-size: 0.875rem; /* Tailwind's text-sm */
}

/* Hides dates belonging to the adjacent months */
.v3dp__element__button__day[disabled] {
  visibility: hidden; /* Or use 'opacity: 0;' to maintain the grid layout spacing */
}
</style>
